const translations = {
  Español: {
    appTitle: "Cancionero Litúrgico",
    appSubtitle: "Cantos para cada momento de la Santa Misa", // Español
    addSongButton: "Agregar Canto",
    importSongsButton: "Importar Cantos",
    cancelButton: "Cancelar",
    cancelEditButton: "Cancelar Edición",
    saveChangesButton: "Guardar Cambios",
    editSongTitle: "Editar Canto",
    addSongTitle: "Agregar Nuevo Canto",
    songTitleLabel: "Título del Canto",
    categoryLabel: "Categoría",
    languageLabel: "Idioma",
    spotifyLabel: "Enlace de Spotify",
    youtubeLabel: "Enlace de YouTube",
    sheetMusicLabel: "Partitura (PDF, JPG, PNG)",
    sheetMusicPlaceholder: "Sube un archivo o pega una URL",
    lyricsLabel: "Letra",
    currentFile: "Archivo actual:",
    deleteSongButton: "Eliminar Canto",
    filterByLanguage: "Filtrar por Idioma",
    categoryAll: "Todos",
    noSongsFound: "No se encontraron cantos. ¡Es hora de añadir algunos!",
    viewDetails: "Ver detalles",
    selectSong: "Seleccionar canto",
    deselectSong: "Deseleccionar canto",
    listenOnSpotify: "Escuchar en Spotify",
    watchOnYouTube: "Ver en YouTube",
    viewSheetMusic: "Ver Partitura",
    viewLyrics: "Ver Letra",
    modalLyricsTitle: "Letra de",
    lyricsTitle: "Letra",
    searchPlaceholder: "Buscar cantos…",
    // Traducciones de idiomas
    language_Alemán: "Alemán",
    language_Catalán: "Catalán",
    language_Español: "Español",
    language_Francés: "Francés",
    language_Gallego: "Gallego",
    language_Inglés: "Inglés",
    language_Italiano: "Italiano",
    language_Latín: "Latín",
    language_Portugués: "Portugués",
    language_Vasco: "Vasco",
    language_Otro: "Otro",
    categories: {
  "Todos": "Todos",
  "Entrada": "Entrada",
  "Penitencia": "Penitencia",
  "Gloria": "Gloria",
  "Aleluya": "Aleluya",
  "Credo": "Credo",
  "Ofertorio": "Ofertorio",
  "Santo": "Santo",
  "Padre Nuestro": "Padre Nuestro",
  "Paz": "Paz",
  "Cordero de Dios": "Cordero de Dios",
  "Comunión": "Comunión",
  "Salida": "Salida",
  "Marianas": "Marianas",
  "Espíritu Santo": "Espíritu Santo",
      "Adviento": "Adviento",
    "Navidad": "Navidad"
}
  },
  English: {
    appTitle: "Liturgical Songbook",
    appSubtitle: "Songs for every moment of the Holy Mass", // Inglés
    addSongButton: "Add Song",
    importSongsButton: "Import Songs",
    cancelButton: "Cancel",
    cancelEditButton: "Cancel Edit",
    saveChangesButton: "Save Changes",
    editSongTitle: "Edit Song",
    addSongTitle: "Add New Song",
    songTitleLabel: "Song Title",
    categoryLabel: "Category",
    languageLabel: "Language",
    spotifyLabel: "Spotify Link",
    youtubeLabel: "YouTube Link",
    sheetMusicLabel: "Sheet Music (PDF, JPG, PNG)",
    sheetMusicPlaceholder: "Upload a file or paste a URL",
    lyricsLabel: "Lyrics",
    currentFile: "Current file:",
    deleteSongButton: "Delete Song",
    filterByLanguage: "Filter by Language",
    categoryAll: "All",
    noSongsFound: "No songs found. Time to add some!",
    viewDetails: "View details",
    selectSong: "Select song",
    deselectSong: "Deselect song",
    listenOnSpotify: "Listen on Spotify",
    watchOnYouTube: "Watch on YouTube",
    viewSheetMusic: "View Sheet Music",
    viewLyrics: "View Lyrics",
    modalLyricsTitle: "Lyrics for",
searchPlaceholder: "Search hymns…",    


    // Language translations
    language_Alemán: "German",
    language_Catalán: "Catalan",
    language_Español: "Spanish",
    language_Francés: "French",
    language_Gallego: "Galician",
    language_Inglés: "English",
    language_Italiano: "Italian",
    language_Latín: "Latin",
    language_Portugués: "Portuguese",
    language_Vasco: "Basque",
    language_Otro: "Other",
  categories: {
  "Todos": "All",
  "Entrada": "Entrance",
  "Penitencia": "Penitential Act",
  "Gloria": "Gloria",
  "Aleluya": "Alleluia",
  "Credo": "Creed",
  "Ofertorio": "Offertory",
  "Santo": "Holy (Sanctus)",
  "Padre Nuestro": "Our Father",
  "Paz": "Peace",
  "Cordero de Dios": "Lamb of God",
  "Comunión": "Communion",
  "Salida": "Recessional",
  "Marianas": "Marian",
  "Espíritu Santo": "Holy Spirit",

    "Adviento": "Advent",
    "Navidad": "Christmas"
}
},
  German: {
  appTitle: "Liturgisches Gesangbuch",
  appSubtitle: "Lieder für jeden Moment der Heiligen Messe", // Alemán
  addSongButton: "Lied hinzufügen",
  importSongsButton: "Lieder importieren",
  cancelButton: "Abbrechen",
  cancelEditButton: "Bearbeitung abbrechen",
  saveChangesButton: "Änderungen speichern",
  editSongTitle: "Lied bearbeiten",
  addSongTitle: "Neues Lied hinzufügen",
  songTitleLabel: "Liedtitel",
  categoryLabel: "Kategorie",
  languageLabel: "Sprache",
  spotifyLabel: "Spotify-Link",
  youtubeLabel: "YouTube-Link",
  sheetMusicLabel: "Noten (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Datei hochladen oder URL einfügen",
  lyricsLabel: "Liedtext",
  currentFile: "Aktuelle Datei:",
  deleteSongButton: "Lied löschen",
  filterByLanguage: "Nach Sprache filtern",
  categoryAll: "Alle",
  noSongsFound: "Keine Lieder gefunden. Zeit, welche hinzuzufügen!",
  viewDetails: "Details anzeigen",
  selectSong: "Lied auswählen",
  deselectSong: "Lied abwählen",
  listenOnSpotify: "Auf Spotify anhören",
  watchOnYouTube: "Auf YouTube ansehen",
  viewSheetMusic: "Noten anzeigen",
  viewLyrics: "Liedtext anzeigen",
  modalLyricsTitle: "Liedtext von",
  lyricsTitle: "Liedtext",
  searchPlaceholder: "Lieder suchen…",
  language_Alemán: "Deutsch",
  language_Catalán: "Katalanisch",
  language_Español: "Spanisch",
  language_Francés: "Französisch",
  language_Gallego: "Galicisch",
  language_Inglés: "Englisch",
  language_Italiano: "Italienisch",
  language_Latín: "Latein",
  language_Portugués: "Portugiesisch",
  language_Vasco: "Baskisch",
  language_Otro: "Andere",
categories: {
  "Todos": "Alle",
  "Entrada": "Einzug",
  "Penitencia": "Bußakt",
  "Gloria": "Gloria",
  "Aleluya": "Halleluja",
  "Credo": "Glaubensbekenntnis",
  "Ofertorio": "Gabenbereitung",
  "Santo": "Heilig (Sanctus)",
  "Padre Nuestro": "Vaterunser",
  "Paz": "Friedensgruß",
  "Cordero de Dios": "Agnus Dei",
  "Comunión": "Kommunion",
  "Salida": "Schlusslied",
  "Marianas": "Marienlieder",
  "Espíritu Santo": "Heiliger Geist",
    "Adviento": "Advent",
    "Navidad": "Weihnachten"
}
},
French: {
  appTitle: "Recueil Liturgique",
  appSubtitle: "Chants pour chaque moment de la Sainte Messe", // Francés
  addSongButton: "Ajouter un chant",
  importSongsButton: "Importer des chants",
  cancelButton: "Annuler",
  cancelEditButton: "Annuler la modification",
  saveChangesButton: "Enregistrer les modifications",
  editSongTitle: "Modifier le chant",
  addSongTitle: "Ajouter un nouveau chant",
  songTitleLabel: "Titre du chant",
  categoryLabel: "Catégorie",
  languageLabel: "Langue",
  spotifyLabel: "Lien Spotify",
  youtubeLabel: "Lien YouTube",
  sheetMusicLabel: "Partition (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Téléversez un fichier ou collez une URL",
  lyricsLabel: "Paroles",
  currentFile: "Fichier actuel :",
  deleteSongButton: "Supprimer le chant",
  filterByLanguage: "Filtrer par langue",
  categoryAll: "Tous",
  noSongsFound: "Aucun chant trouvé. Il est temps d’en ajouter !",
  viewDetails: "Voir les détails",
  selectSong: "Sélectionner un chant",
  deselectSong: "Désélectionner le chant",
  listenOnSpotify: "Écouter sur Spotify",
  watchOnYouTube: "Regarder sur YouTube",
  viewSheetMusic: "Voir la partition",
  viewLyrics: "Voir les paroles",
  modalLyricsTitle: "Paroles de",
  lyricsTitle: "Paroles",
  searchPlaceholder: "Rechercher des chants…",
  language_Alemán: "Allemand",
  language_Catalán: "Catalan",
  language_Español: "Espagnol",
  language_Francés: "Français",
  language_Gallego: "Galicien",
  language_Inglés: "Anglais",
  language_Italiano: "Italien",
  language_Latín: "Latin",
  language_Portugués: "Portugais",
  language_Vasco: "Basque",
  language_Otro: "Autre",
  categories: {
  "Todos": "Tous",
  "Entrada": "Entrée",
  "Penitencia": "Acte pénitentiel",
  "Gloria": "Gloire (Gloria)",
  "Aleluya": "Alléluia",
  "Credo": "Credo",
  "Ofertorio": "Offertoire",
  "Santo": "Saint (Sanctus)",
  "Padre Nuestro": "Notre Père",
  "Paz": "Paix",
  "Cordero de Dios": "Agneau de Dieu",
  "Comunión": "Communion",
  "Salida": "Sortie",
  "Marianas": "Mariales",
  "Espíritu Santo": "Esprit Saint",
     "Adviento": "Avènement",
    "Navidad": "Noël"
}

},
Italian: {
  appTitle: "Cantico Liturgico",
  appSubtitle: "Canti per ogni momento della Santa Messa", // Italiano
  addSongButton: "Aggiungi canto",
  importSongsButton: "Importa canti",
  cancelButton: "Annulla",
  cancelEditButton: "Annulla modifica",
  saveChangesButton: "Salva modifiche",
  editSongTitle: "Modifica canto",
  addSongTitle: "Aggiungi nuovo canto",
  songTitleLabel: "Titolo del canto",
  categoryLabel: "Categoria",
  languageLabel: "Lingua",
  spotifyLabel: "Link Spotify",
  youtubeLabel: "Link YouTube",
  sheetMusicLabel: "Spartito (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Carica un file o incolla un URL",
  lyricsLabel: "Testo",
  currentFile: "File attuale:",
  deleteSongButton: "Elimina canto",
  filterByLanguage: "Filtra per lingua",
  categoryAll: "Tutti",
  noSongsFound: "Nessun canto trovato. È ora di aggiungerne uno!",
  viewDetails: "Vedi dettagli",
  selectSong: "Seleziona canto",
  deselectSong: "Deseleziona canto",
  listenOnSpotify: "Ascolta su Spotify",
  watchOnYouTube: "Guarda su YouTube",
  viewSheetMusic: "Vedi spartito",
  viewLyrics: "Vedi testo",
  modalLyricsTitle: "Testo di",
  lyricsTitle: "Testo",
  searchPlaceholder: "Cerca canti…",
  language_Alemán: "Tedesco",
  language_Catalán: "Catalano",
  language_Español: "Spagnolo",
  language_Francés: "Francese",
  language_Gallego: "Galiziano",
  language_Inglés: "Inglese",
  language_Italiano: "Italiano",
  language_Latín: "Latino",
  language_Portugués: "Portoghese",
  language_Vasco: "Basco",
  language_Otro: "Altro",
  categories: {
  "Todos": "Tutti",
  "Entrada": "Ingresso",
  "Penitencia": "Atto penitenziale",
  "Gloria": "Gloria",
  "Aleluya": "Alleluia",
  "Credo": "Credo",
  "Ofertorio": "Offertorio",
  "Santo": "Santo",
  "Padre Nuestro": "Padre Nostro",
  "Paz": "Pace",
  "Cordero de Dios": "Agnello di Dio",
  "Comunión": "Comunione",
  "Salida": "Canto finale",
  "Marianas": "Mariani",
  "Espíritu Santo": "Spirito Santo",
     "Adviento": "Avvento",
    "Navidad": "Natale"
    
}

},
Latin: {
  appTitle: "Cantus Liturgicus",
  appSubtitle: "Canti pro unoquoque momento Missae Sanctae", // Latín
  addSongButton: "Adde Cantum",
  importSongsButton: "Importa Cantus",
  cancelButton: "Cancella",
  cancelEditButton: "Cancella Editionem",
  saveChangesButton: "Serva Mutationes",
  editSongTitle: "Edita Cantum",
  addSongTitle: "Adde Novum Cantum",
  songTitleLabel: "Titulus Canti",
  categoryLabel: "Categoria",
  languageLabel: "Lingua",
  spotifyLabel: "Nexus Spotify",
  youtubeLabel: "Nexus YouTube",
  sheetMusicLabel: "Partitura (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Adde fasciculum vel inere nexum",
  lyricsLabel: "Verba",
  currentFile: "Fasciculus hodiernus:",
  deleteSongButton: "Dele Cantum",
  filterByLanguage: "Filtra per Linguam",
  categoryAll: "Omnia",
  noSongsFound: "Nulli cantus inventi. Tempus est aliquos addere!",
  viewDetails: "Vide Singula",
  selectSong: "Selige Cantum",
  deselectSong: "Deselige Cantum",
  listenOnSpotify: "Audi in Spotify",
  watchOnYouTube: "Vide in YouTube",
  viewSheetMusic: "Vide Partituram",
  viewLyrics: "Vide Verba",
  modalLyricsTitle: "Verba de",
  lyricsTitle: "Verba",
  searchPlaceholder: "Quaere cantus…",
  language_Alemán: "Theodisce",
  language_Catalán: "Catalanice",
  language_Español: "Hispanice",
  language_Francés: "Gallice",
  language_Gallego: "Gallaice",
  language_Inglés: "Anglice",
  language_Italiano: "Italice",
  language_Latín: "Latine",
  language_Portugués: "Lusitanice",
  language_Vasco: "Vasconice",
  language_Otro: "Aliud",
  categories: {
  "Todos": "Tutti",
  "Entrada": "Ingresso",
  "Penitencia": "Atto penitenziale",
  "Gloria": "Gloria",
  "Aleluya": "Alleluia",
  "Credo": "Credo",
  "Ofertorio": "Offertorio",
  "Santo": "Santo",
  "Padre Nuestro": "Padre Nostro",
  "Paz": "Pace",
  "Cordero de Dios": "Agnello di Dio",
  "Comunión": "Comunione",
  "Salida": "Canto finale",
  "Marianas": "Mariani",
  "Espíritu Santo": "Spirito Santo",
     "Adviento": "Adventus",
    "Navidad": "Christmas"
}

},
Catalan: {
  appTitle: "Cançoner Litúrgic",
  appSubtitle: "Cants per a cada moment de la Santa Missa", // Catalán
  addSongButton: "Afegir Cant",
  importSongsButton: "Importar Cants",
  cancelButton: "Cancel·lar",
  cancelEditButton: "Cancel·lar Edició",
  saveChangesButton: "Desar Canvis",
  editSongTitle: "Editar Cant",
  addSongTitle: "Afegir Nou Cant",
  songTitleLabel: "Títol del Cant",
  categoryLabel: "Categoria",
  languageLabel: "Idioma",
  spotifyLabel: "Enllaç de Spotify",
  youtubeLabel: "Enllaç de YouTube",
  sheetMusicLabel: "Partitura (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Puja un fitxer o enganxa un URL",
  lyricsLabel: "Lletra",
  currentFile: "Fitxer actual:",
  deleteSongButton: "Eliminar Cant",
  filterByLanguage: "Filtrar per Idioma",
  categoryAll: "Tots",
  noSongsFound: "No s’han trobat cants. És hora d’afegir-ne!",
  viewDetails: "Veure detalls",
  selectSong: "Seleccionar cant",
  deselectSong: "Desseleccionar cant",
  listenOnSpotify: "Escoltar a Spotify",
  watchOnYouTube: "Veure a YouTube",
  viewSheetMusic: "Veure Partitura",
  viewLyrics: "Veure Lletra",
  modalLyricsTitle: "Lletra de",
  lyricsTitle: "Lletra",
  searchPlaceholder: "Cerca cants…",
  language_Alemán: "Alemany",
  language_Catalán: "Català",
  language_Español: "Espanyol",
  language_Francés: "Francès",
  language_Gallego: "Gallec",
  language_Inglés: "Anglès",
  language_Italiano: "Italià",
  language_Latín: "Llatí",
  language_Portugués: "Portuguès",
  language_Vasco: "Basc",
  language_Otro: "Altres",
  categories: {
  "Todos": "Tots",
  "Entrada": "Entrada",
  "Penitencia": "Acte penitencial",
  "Gloria": "Glòria",
  "Aleluya": "Al·leluia",
  "Credo": "Creu",
  "Ofertorio": "Ofertori",
  "Santo": "Sant",
  "Padre Nuestro": "Pare Nostre",
  "Paz": "Pau",
  "Cordero de Dios": "Anyell de Déu",
  "Comunión": "Comunió",
  "Salida": "Sortida",
  "Marianas": "Marianes",
  "Espíritu Santo": "Esperit Sant",
     "Adviento": "Advents",
    "Navidad": "Nadals"
}

},
Basque: {
  appTitle: "Liturgia Abesti-liburua",
  appSubtitle: "Kantuak Meza Santuaren une bakoitzerako", // Vasco
  addSongButton: "Gehitu Abestia",
  importSongsButton: "Inportatu Abestiak",
  cancelButton: "Utzi",
  cancelEditButton: "Editatzea Utzi",
  saveChangesButton: "Aldaketak Gorde",
  editSongTitle: "Editatu Abestia",
  addSongTitle: "Gehitu Abesti Berria",
  songTitleLabel: "Abestiaren Izenburua",
  categoryLabel: "Kategoria",
  languageLabel: "Hizkuntza",
  spotifyLabel: "Spotify Esteka",
  youtubeLabel: "YouTube Esteka",
  sheetMusicLabel: "Partitura (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Igo fitxategia edo itsatsi URLa",
  lyricsLabel: "Letra",
  currentFile: "Uneko fitxategia:",
  deleteSongButton: "Ezabatu Abestia",
  filterByLanguage: "Iragazi Hizkuntzaren arabera",
  categoryAll: "Guztiak",
  noSongsFound: "Ez da abestirik aurkitu. Gehitzeko unea da!",
  viewDetails: "Ikusi xehetasunak",
  selectSong: "Hautatu abestia",
  deselectSong: "Desautatu abestia",
  listenOnSpotify: "Entzun Spotify-n",
  watchOnYouTube: "Ikusi YouTube-n",
  viewSheetMusic: "Ikusi Partitura",
  viewLyrics: "Ikusi Letra",
  modalLyricsTitle: "Letra: ",
  lyricsTitle: "Letra",
  searchPlaceholder: "Bilatu abestiak…",
  language_Alemán: "Alemaniera",
  language_Catalán: "Katalana",
  language_Español: "Gaztelania",
  language_Francés: "Frantsesa",
  language_Gallego: "Galiziera",
  language_Inglés: "Ingelesa",
  language_Italiano: "Italiera",
  language_Latín: "Latina",
  language_Portugués: "Portugesa",
  language_Vasco: "Euskara",
  language_Otro: "Beste batzuk",
  categories: {
  "Todos": "Guztiak",
  "Entrada": "Sarrera",
  "Penitencia": "Penitentzia ekintza",
  "Gloria": "Aintza",
  "Aleluya": "Haleluia",
  "Credo": "Sinbolo apostolikoa",
  "Ofertorio": "Ofertorioa",
  "Santo": "Santu",
  "Padre Nuestro": "Aita Gurea",
  "Paz": "Bakea",
  "Cordero de Dios": "Jainkoaren Bildotsa",
  "Comunión": "Komunioa",
  "Salida": "Amaierako kanta",
  "Marianas": "Marianoak",
  "Espíritu Santo": "Espiritu Santua",
    "Adviento": "Etorrera",
    "Navidad": "Gabonak"
    
}

},
Galician: {
  appTitle: "Cancioneiro Litúrxico",
  appSubtitle: "Cantos para cada momento da Santa Misa",
  addSongButton: "Engadir Canto",
  importSongsButton: "Importar Cantos",
  cancelButton: "Cancelar",
  cancelEditButton: "Cancelar Edición",
  saveChangesButton: "Gardar Cambios",
  editSongTitle: "Editar Canto",
  addSongTitle: "Engadir Novo Canto",
  songTitleLabel: "Título do Canto",
  categoryLabel: "Categoría",
  languageLabel: "Idioma",
  spotifyLabel: "Ligazón de Spotify",
  youtubeLabel: "Ligazón de YouTube",
  sheetMusicLabel: "Partitura (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Sube un ficheiro ou pega unha URL",
  lyricsLabel: "Letra",
  currentFile: "Ficheiro actual:",
  deleteSongButton: "Eliminar Canto",
  filterByLanguage: "Filtrar por Idioma",
  categoryAll: "Todos",
  noSongsFound: "Non se atoparon cantos. É hora de engadir algúns!",
  viewDetails: "Ver detalles",
  selectSong: "Seleccionar canto",
  deselectSong: "Deseleccionar canto",
  listenOnSpotify: "Escoitar en Spotify",
  watchOnYouTube: "Ver en YouTube",
  viewSheetMusic: "Ver Partitura",
  viewLyrics: "Ver Letra",
  modalLyricsTitle: "Letra de",
  lyricsTitle: "Letra",
  searchPlaceholder: "Buscar cantos…",
  language_Alemán: "Alemán",
  language_Catalán: "Catalán",
  language_Español: "Español",
  language_Francés: "Francés",
  language_Gallego: "Galego",
  language_Inglés: "Inglés",
  language_Italiano: "Italiano",
  language_Latín: "Latín",
  language_Portugués: "Portugués",
  language_Vasco: "Éuscaro",
  language_Otro: "Outro",
  categories: {
  "Todos": "Todos",
  "Entrada": "Entrada",
  "Penitencia": "Acto penitencial",
  "Gloria": "Gloria",
  "Aleluya": "Aleluia",
  "Credo": "Credo",
  "Ofertorio": "Ofertorio",
  "Santo": "Santo",
  "Padre Nuestro": "Pai Noso",
  "Paz": "Paz",
  "Cordero de Dios": "Cordeiro de Deus",
  "Comunión": "Comuñón",
  "Salida": "Saída",
  "Marianas": "Marianas",
  "Espíritu Santo": "Espírito Santo",
    "Adviento": "Advento",
    "Navidad": "Nadal"
}

},
Portuguese: {
  appTitle: "Cancioneiro Litúrgico",
  appSubtitle: "Cantos para cada momento da Santa Missa",
  addSongButton: "Adicionar Canto",
  importSongsButton: "Importar Cantos",
  cancelButton: "Cancelar",
  cancelEditButton: "Cancelar Edição",
  saveChangesButton: "Salvar Alterações",
  editSongTitle: "Editar Canto",
  addSongTitle: "Adicionar Novo Canto",
  songTitleLabel: "Título do Canto",
  categoryLabel: "Categoria",
  languageLabel: "Idioma",
  spotifyLabel: "Link do Spotify",
  youtubeLabel: "Link do YouTube",
  sheetMusicLabel: "Partitura (PDF, JPG, PNG)",
  sheetMusicPlaceholder: "Envie um arquivo ou cole uma URL",
  lyricsLabel: "Letra",
  currentFile: "Arquivo atual:",
  deleteSongButton: "Excluir Canto",
  filterByLanguage: "Filtrar por Idioma",
  categoryAll: "Todos",
  noSongsFound: "Nenhum canto encontrado. Hora de adicionar alguns!",
  viewDetails: "Ver detalhes",
  selectSong: "Selecionar canto",
  deselectSong: "Desselecionar canto",
  listenOnSpotify: "Ouvir no Spotify",
  watchOnYouTube: "Assistir no YouTube",
  viewSheetMusic: "Ver Partitura",
  viewLyrics: "Ver Letra",
  modalLyricsTitle: "Letra de",
  lyricsTitle: "Letra",
  searchPlaceholder: "Buscar cantos…",
  language_Alemán: "Alemão",
  language_Catalán: "Catalão",
  language_Español: "Espanhol",
  language_Francés: "Francês",
  language_Gallego: "Galego",
  language_Inglés: "Inglês",
  language_Italiano: "Italiano",
  language_Latín: "Latim",
  language_Portugués: "Português",
  language_Vasco: "Basco",
  language_Otro: "Outro",
  categories: {
  "Todos": "Todos",
  "Entrada": "Entrada",
  "Penitencia": "Ato penitencial",
  "Gloria": "Glória",
  "Aleluya": "Aleluia",
  "Credo": "Credo",
  "Ofertorio": "Ofertório",
  "Santo": "Santo",
  "Padre Nuestro": "Pai-Nosso",
  "Paz": "Paz",
  "Cordero de Dios": "Cordeiro de Deus",
  "Comunión": "Comunhão",
  "Salida": "Saída",
  "Marianas": "Marianas",
  "Espíritu Santo": "Espírito Santo",
    "Adviento": "Advento",
    "Navidad": "Natal"
}

}
};

export default translations;
